// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"56a97e04b24fb1615776","655":"27e84783dfb7bce611f2"}[chunkId] + ".js";
};